import { render, staticRenderFns } from "./AgeIntroModule.vue?vue&type=template&id=519f3952&scoped=true&"
import script from "./AgeIntroModule.vue?vue&type=script&lang=js&"
export * from "./AgeIntroModule.vue?vue&type=script&lang=js&"
import style0 from "./AgeIntroModule.vue?vue&type=style&index=0&id=519f3952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519f3952",
  null
  
)

export default component.exports